// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import CovidStaff from '../_raw/service/icon_covid_staff.svg';
import withIconProps from '../withIconProps';

export default withIconProps(CovidStaff);
